import { Lead } from '@/types/apply/Lead.type'
import { OpePlan } from '@/types/apply/OpePlan.type'
import { Bundle, Flow } from '@/types/form/Apply'

export type State = {
    countryList: Array<any>
    lead: Lead | null
    plan: OpePlan | null
    bundle: Bundle | null
    flow: Flow | null
}

export default (): State => {
    const leadStr = window.sessionStorage.getItem('lead')
    const leadSession = leadStr ? JSON.parse(leadStr) : null
    // @ts-ignore
    const leadPayload = window.payload?.lead

    return {
        countryList: [],
        lead: leadPayload || leadSession,
        plan: null,
        bundle: null,
        flow: null,
    }
}
